import EventManager from '../__internals__/EventManager'
import InternalAppSchema from '../__internals__/InternalAppSchema'

const trackEvent =
  (eventManager: EventManager) => (eventData: InternalAppSchema) => {
    try {
      // Discard some global data between calls and return only what we care about
      const { task, ...retainedGlobalData } = eventManager.prepareDataLayer()

      // eventData may also have browser on it - which we'd rather trust from the global layer, so we discard
      const { browser, ...restEventData } = eventData

      // If the task is done, then do not carry over task data
      // This will clear out anything else user set between events
      if (
        task?.status === 'success' ||
        task?.status === 'fail' ||
        task?.status === 'cancelled'
      ) {
        eventManager.addEvent({
          ...eventManager.setAppDataAtGlobalDataLayer(retainedGlobalData),
          ...restEventData,
        })
      }
      // Set App related data along with Task data on the Global Data layer if Task is ongoing("initiated")
      // This will clear out anything else user set between events
      else {
        eventManager.addEvent({
          ...eventManager.setAppDataAtGlobalDataLayer(retainedGlobalData),
          task,
          ...restEventData,
        })
      }
    } catch (err) {
      // It turns out Firefly actually eats their own errors; if it has a CORS or other issue, this isn't triggered.
      console.warn(
        'An error occurred while sending an event to Firefly Internal Insights.',
      )
      if (process.env.NODE_ENV === 'development') {
        console.warn('Error:', err)
        console.warn('Event Data:', eventData)
      }
    }
  }

export default trackEvent
